import { indexBy, prop } from "ramda";

const DEFAULT_LOCALE = "en-US";

const LANGUAGES = [
  { key: "en-US", text: "English (US)", basename: "" },
  { key: "es-419", text: "Español", basename: "es" },
  { key: "es-ES", text: "Español (España)", basename: "es-es" },
  { key: "pt-BR", text: "Português (Brasil)", basename: "pt-br" },
  { key: "pt-PT", text: "Português (Portugal)", basename: "pt-pt" },
  { key: "fr-FR", text: "Français (France)", basename: "fr" },
  { key: "de-DE", text: "Deutsch", basename: "de" },
  { key: "ar-SA", text: "العربية", basename: "ar" },
  { key: "it-IT", text: "Italiano", basename: "it" },
  { key: "ru-RU", text: "Русский", basename: "ru" },
  { key: "hi-IN", text: "हिंदी", basename: "hi"},
];
const LANGUAGES_BY_BASENAME = indexBy(prop("basename"), LANGUAGES);
const LANGUAGES_BY_KEY = indexBy(prop("key"), LANGUAGES);
const LANGUAGES_RTL = ["ar-SA"];
const LANGUAGE_EXTENSIONS = [{ key: "ar-SA", extension: "-u-nu-latn" }];
const LANGUAGE_EXTENSIONS_BY_KEY = indexBy(prop("key"), LANGUAGE_EXTENSIONS);

const HELP_CENTER_LOCALES_BY_KEY = {
  "en-US": "en-us",
  "es-ES": "es",
  "pt-BR": "pt",
  "pt-PT": "pt",
  "fr-FR": "fr",
  "de-DE": "de",
  "it-IT": "it",
  "ru-RU": "ru",
  "es-419": "es",
  "ar-SA": "ar",
  'hi-IN': 'hi',
};

export {
  LANGUAGES_RTL,
  LANGUAGES,
  DEFAULT_LOCALE,
  LANGUAGES_BY_BASENAME,
  LANGUAGES_BY_KEY,
  LANGUAGE_EXTENSIONS_BY_KEY,
  HELP_CENTER_LOCALES_BY_KEY,
};
